exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".datesplit-field .datesplit-text{color:#545454}.datesplit-field .datesplit-input{height:41px}.datesplit-field.warning-datesplit{background:rgba(248,209,27,.1);padding:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./directives/freeforms/datesplit/datesplit.scss
// module id = 389
// module chunks = 0